'use client';

import { GridColDef } from '@mui/x-data-grid';
import Link from 'next/link';

import { SetShowDialog } from '../../../types';
import { UtilizationDetailsModal } from './utilizationDetailsModal';

export const getMustTakesColumns = (
	setShowDialog: SetShowDialog,
	getUrlToSubscriptionPage: (...x: any) => string,
	facilityId: string,
): GridColDef[] => [
	{
		field: 'rateName',
		headerName: 'Rate',
		headerAlign: 'center',
		align: 'center',
		editable: false,
		groupable: false,
		filterable: false,
		aggregable: false,
		flex: 1,
	},
	{
		field: 'sublotName',
		headerName: 'Sublot',
		headerAlign: 'center',
		align: 'center',
		editable: false,
		groupable: false,
		filterable: false,
		aggregable: false,
		flex: 1,
	},
	{
		field: 'allowsConversions',
		headerName: 'Allows Conversions?',
		headerAlign: 'center',
		align: 'center',
		editable: false,
		groupable: false,
		filterable: false,
		aggregable: false,
		flex: 1,
		valueFormatter: ({ value }) => (value ? 'Yes' : 'No'),
	},
	{
		field: 'utilization',
		headerName: 'Utilization',
		headerAlign: 'center',
		align: 'center',
		editable: false,
		groupable: false,
		filterable: false,
		sortable: false,
		aggregable: false,
		flex: 1,
		valueGetter: ({ row }) => `${row.parkerCount} / ${row.mustTakeCount}`,
	},
	{
		field: 'details',
		headerName: '',
		align: 'center',
		flex: 1,
		editable: false,
		groupable: false,
		renderCell: (params) => {
			// SSR from owner portal won't be able to pass setshowdialog so we will have to put this modal in a view
			if (!setShowDialog) {
				return (
					<Link
						href={{
							pathname: `/lease-detail/${params.row.id}/utilization-details`,
							query: {
								facilityId,
							},
						}}
						target='_blank'
						rel='noopener noreferrer'
					>
						<div style={{ color: 'blue', cursor: 'pointer' }}>View Details</div>
					</Link>
				);
			}
			const onModalClose = () => setShowDialog(null);

			return (
				<div
					style={{ color: 'blue', cursor: 'pointer' }}
					onClick={() => {
						setShowDialog(
							<UtilizationDetailsModal
								leasingCountAndRateId={params.row.id}
								facilityId={facilityId}
								getUrlToSubscriptionPage={getUrlToSubscriptionPage}
								onModalClose={onModalClose}
							/>,
						);
					}}
				>
					View Details
				</div>
			);
		},
	},
];
